var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreatePostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9705 26.4993H13.1767C10.8736 26.4993 9 24.6775 9 22.438V13.8878C9 11.6483 10.8736 9.82642 13.1767 9.82642H16.6943C17.0586 9.82642 17.3541 10.1137 17.3541 10.4679C17.3541 10.8221 17.0586 11.1094 16.6943 11.1094H13.1767C11.601 11.1094 10.3189 12.3561 10.3189 13.8884V22.4386C10.3189 23.9708 11.601 25.2175 13.1767 25.2175H21.9699C23.5456 25.2175 24.8277 23.9708 24.8277 22.4386V19.4029C24.8277 19.0487 25.1232 18.7614 25.4875 18.7614C25.8517 18.7614 26.1472 19.0487 26.1472 19.4029V22.4386C26.1472 24.6781 24.2736 26.4999 21.9705 26.4999V26.4993Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3225 9.98054L26.4919 9.16826C25.5806 8.27696 24.0944 8.27869 23.1778 9.1648L17.6276 14.5542C17.328 14.8559 17.1097 15.2361 17.0088 15.6468L16.4737 17.9008C16.3479 18.3963 16.5015 18.9103 16.8735 19.2744C17.2455 19.6384 17.7736 19.7907 18.2838 19.6713L20.6047 19.1642C21.0277 19.0684 21.4205 18.8578 21.732 18.5688L27.3065 13.2037C28.2231 12.3175 28.2338 10.8724 27.3225 9.98111V9.98054ZM20.7774 17.6227C20.6463 17.749 20.4908 17.8275 20.298 17.869L17.9836 18.3825C17.9213 18.3946 17.8839 18.3825 17.8406 18.3398C17.7973 18.2971 17.7848 18.2607 17.7973 18.2008L18.339 15.9532C18.3829 15.7657 18.4641 15.6151 18.5953 15.4882L22.8729 11.3282L23.9829 12.4012L25.0805 13.4863L20.778 17.6215L20.7774 17.6227ZM26.0529 12.5587L24.9494 11.4672L23.8334 10.3878L24.1389 10.0925C24.5133 9.73074 25.16 9.73247 25.5255 10.0901L25.9473 10.5026L26.3691 10.9151C26.7352 11.2728 26.7328 11.9016 26.359 12.2633L26.0535 12.5587H26.0529Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePostIcon);
export default __webpack_public_path__ + "static/media/create-post-icon.7a0b8026.svg";
export { ForwardRef as ReactComponent };